export default "__VITE_ASSET__oP9SoDWu__"